import { initGeneral, setGeneral } from '@modules/general';
import { useDispatch } from '@stores';
import { IStoreGeneral } from '@types';
import { useCallback } from 'react';

const useGeneralActions = () => {
  const dispatch = useDispatch();

  const onInitGeneral = useCallback(() => {
    dispatch(initGeneral());
  }, [dispatch]);

  const onSetGeneral = useCallback(
    (payload: Partial<IStoreGeneral>) => {
      dispatch(setGeneral(payload));
    },
    [dispatch]
  );

  return { onInitGeneral, onSetGeneral };
};

export default useGeneralActions;
